import {
  AUTH_SUCCESS,
  VALIDATE_CREDENTIALS_SUCCESS,
  VALIDATE_CREDENTIALS_FAILED,
  VALIDATE_TOKEN_REQUESTED,
  VALIDATE_TOKEN_FAILED,
  SEND_RESET_EMAIL_REQUESTED,
  SEND_RESET_EMAIL_FAILED,
  SEND_RESET_EMAIL_SUCCESS,
  CONFIRM_PASSWORD_RESET_REQUESTED,
  CONFIRM_PASSWORD_RESET_SUCCESS,
  CONFIRM_PASSWORD_RESET_FAILED,
  VERIFICATION_REQUESTED,
  VERIFICATION_SUCCESS,
  VERIFICATION_FAILED,
  REAUTH,
  SET_RECAPTCHA_READY,
  SET_USER_ACCOUNT_TYPE,
  SET_ACCOUNT_MANAGEMENT_REDIRECT
} from '../actionCreators/authActions';
import { RESET_STATE } from '../actionCreators/generalActions';

const initialState = {
  verifying: false,
  verified: true,
  currentUser: {
    id: ''
  },
  reauth: false,
  lastAction: null,
  recaptchaReady: false,
  isAuthenticating: true,
  accountManagementRedirect: false
};

function authReducer(state = { ...initialState }, action) {
  switch (action.type) {
    case VALIDATE_CREDENTIALS_SUCCESS: {
      return {
        ...state,
        currentUser: {
          ...state.currentUser,
          token: action.token
        }
      };
    }

    case VALIDATE_CREDENTIALS_FAILED: {
      return {
        ...state,
        isAuthenticating: false
      };
    }

    case AUTH_SUCCESS: {
      const { email, id, firstname, surname, accountType, term, lastname, internalUser } = action.user;

      return {
        ...state,
        currentUser: {
          ...state.currentUser,
          id: id.toString(),
          authenticated: true,
          email,
          token: action.token,
          accountType,
          term,
          firstname,
          lastname: lastname || surname,
          ...(internalUser ? { internalUser } : {})
        },
        isAuthenticating: false,
        reauth: false
      };
    }

    case VALIDATE_TOKEN_REQUESTED: {
      const isAuthenticating = true;

      return {
        ...state,
        isAuthenticating,
        currentUser: {
          ...state.currentUser,
          token: action.token
        }
      };
    }

    case VALIDATE_TOKEN_FAILED: {
      const isAuthenticating = false;
      return { ...state, isAuthenticating };
    }

    case RESET_STATE:
      return {
        ...initialState,
        currentUser: {},
        recaptchaReady: state.recaptchaReady,
        isAuthenticating: state.isAuthenticating
      };

    case SEND_RESET_EMAIL_REQUESTED: {
      const error = undefined;
      return { ...state, resetEmailProcessing: true, resetEmailError: error };
    }

    case SEND_RESET_EMAIL_FAILED: {
      const processingError = action.error.err;
      return {
        ...state,
        resetEmailProcessing: false,
        resetEmailRequestProcessed: false,
        resetEmailError: processingError
      };
    }

    case SEND_RESET_EMAIL_SUCCESS: {
      return { ...state, resetEmailProcessing: false, resetEmailRequestProcessed: true };
    }

    case CONFIRM_PASSWORD_RESET_REQUESTED: {
      const error = undefined;
      return { ...state, passwordResetProcessing: true, passwordResetError: error };
    }

    case CONFIRM_PASSWORD_RESET_SUCCESS: {
      return { ...state, passwordResetProcessing: false, passwordResetSuccess: true };
    }

    case CONFIRM_PASSWORD_RESET_FAILED: {
      const processingError = action.error.err;
      return {
        ...state,
        passwordResetProcessing: false,
        passwordResetSuccess: false,
        passwordResetError: processingError
      };
    }

    case REAUTH: {
      return {
        ...state,
        reauth: true,
        lastAction: action.lastAction
      };
    }

    case VERIFICATION_REQUESTED: {
      return {
        ...state,
        verifying: true,
        verified: false,
        error: undefined
      };
    }

    case VERIFICATION_SUCCESS: {
      return {
        ...state,
        verifying: false,
        verified: true
      };
    }

    case VERIFICATION_FAILED: {
      const verificationError = action.error.err;
      return {
        ...state,
        verifying: false,
        verified: false,
        error: verificationError
      };
    }

    case SET_RECAPTCHA_READY: {
      return {
        ...state,
        recaptchaReady: action.payload
      };
    }

    case SET_USER_ACCOUNT_TYPE: {
      return {
        ...state,
        currentUser: {
          ...state.currentUser,
          accountType: action.accountType
        }
      };
    }

    case SET_ACCOUNT_MANAGEMENT_REDIRECT: {
      return {
        ...state,
        accountManagementRedirect: true
      };
    }

    default:
      return state;
  }
}

export default authReducer;
